import { gql } from '@apollo/client';

import { STUDENT_FIELDS, DEAL_FIELDS } from './modules';

import { SCHOOL_AND_LANGUAGES_GQL } from './pages';

export const STUDENT_DETAILS_QUERY = gql`
  query StudentApp($appId: String!) {
    Records {
      Students_Applications(where: { id: { equals: $appId } }) {
        _data {
          Student {
            id { value }
            ${STUDENT_FIELDS}
          }
          Deal {
            id { value }
            ${DEAL_FIELDS}
          }
        }
      }
    }
  }`;

export const SCHOOL_AND_LANGUAGES_QUERY = gql`
  query StudentApp($appId: String!) {
    Records {
      Students_Applications(where: { id: { equals: $appId } }) {
        _data {
            ${SCHOOL_AND_LANGUAGES_GQL}
        }
      }
    }
  }`;
